import React from 'react'

import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'

import { rangeQuestionOptions as options } from '../../../../options'
import t from '../../../../translations'
import './QuestionRange.css'
import { Typography } from '@material-ui/core'
import questionIds from './questionIds'
import { describedBy, RequiredMark, QuestionErrorText, SavedNote } from './QuestionValidation'

const QuestionRange = ({ question, setAnswer, answers, showMissingError, isSaved, sectionHeaderId }) => {
  const pickedAnswer = answers && answers[question.questionId]
  const ids = questionIds(question.questionId)

  const pickAnswerHandler = (event) => setAnswer(question.questionId, event.target.value)

  return (
    <div className={'QuestionRange'} id={ids.block}>
      <br />
      <Typography id={ids.caption} variant={'h6'} style={{ fontWeight: 700 }}>
        {question.caption}
        <RequiredMark />
      </Typography>
      <Typography id={ids.description} paragraph={true} variant={'body1'}>{question.description}</Typography>
      <FormControl component={'fieldset'} error={showMissingError} disabled={isSaved}>
        <RadioGroup
          style={{
            justifyContent: 'center',
            textAlign: 'center',
          }}
          row={true}
          onChange={pickAnswerHandler}
          name={question.questionId}
          // RadioGroup z MUI 4.8.3 ustala tryb kontrolowany przy pierwszym renderze (value != null) i porównuje wartość
          // z radiem ściśle (===). Bez zaznaczenia podajemy '' (grupa kontrolowana od początku, więc widać też oceny
          // wstawione przez „OK”), a liczbę z „OK” jako tekst (5 → '5').
          // Tylko wyświetlanie: typ w stanie i w POST bez zmian.
          value={pickedAnswer === undefined || pickedAnswer === null ? '' : String(pickedAnswer)}
          // Nazwa grupy dla czytników ekranu = nagłówek sekcji + treść pytania (to samo pytanie powtarza się przy
          // każdym prowadzącym), opis = opis pytania (wcześniej grupa bez nazwy).
          aria-labelledby={describedBy(sectionHeaderId, ids.caption)}
          aria-describedby={describedBy(
            question.description && ids.description,
            showMissingError && ids.error,
            isSaved && ids.saved
          )}
          aria-required={'true'}
          aria-invalid={showMissingError ? 'true' : undefined}
          // Odpowiedź zapisana przy częściowym zapisie: grupa zablokowana (radia disabled z FormControl).
          aria-disabled={isSaved ? 'true' : undefined}
        >
          {options.map((option, index, arr) => (
            <FormControlLabel
              key={index}
              className={'range-question__radio-button'}
              value={option}
              control={<Radio color={'primary'} />}
              label={option === 'not-present' ? t.pollView.notPresent : option}
              labelPlacement={'bottom'}
            />
          ))}
        </RadioGroup>
        {showMissingError ? <QuestionErrorText id={ids.error}>{t.pollView.missingAnswer}</QuestionErrorText> : null}
        {isSaved ? <SavedNote id={ids.saved} centered={true} /> : null}
      </FormControl>
      <br />
    </div>
  )
}

export default QuestionRange